<script>
import {
  ButtonAlignCenter,
  ButtonFlashRadial,
  ButtonIconPositionShiftLeft,
  ButtonIconActiveHeight,
  ButtonIconPositionHugLeft,
  ButtonIconPassiveHeight,
  ButtonIconActiveWidth,
  ButtonIconPositionHugRight,
  ButtonOverrideLayoutIconAndText,
} from "@kit/components/IconButton.vue";

export const greenButton = {
  foreground: {
    active: "#FFFFFF",
    inactive: "#FFFFFF",
    flash: "#FFFFFF",
    loading: "#FFFFFF",
  },
  background: {
    active: "#447340",
    inactive: "#CCCCCC",
    flash: "#94cc8f",
    loading: "#CCCCCC",
    hover: "#4c8c46",
    borderRadius: "3px",
    padding: "10px",
  },
  iconPosition: ButtonIconPositionShiftLeft,
  align: ButtonAlignCenter,
  flash: ButtonFlashRadial,
  allowPropagate: false,
  loader: {
    fill: "#CCCCCC",
    wheel: {
      gif: "Spinner-0.4s-310px-ffffff-transparent",
      spinnerStyle:
        "width:120%; height:120%; top:-10%; left:-10%; background-size:contain; background-position:center; background-repeat:no-repeat; position:absolute;",
    },
  },
};

export const redButton = {
  ...greenButton,
  background: {
    active: "#d2301e",
    inactive: "#CCCCCC",
    flash: "#f69a90",
    loading: "#CCCCCC",
    hover: "#FF0000",
    borderRadius: "5px",
    padding: "10px",
  },
};

export const blueButton = {
  foreground: {
    active: "#FFFFFF",
    inactive: "#FFFFFF",
    flash: "#FFFFFF",
    loading: "#FFFFFF",
  },
  background: {
    active: "#3e63a3",
    inactive: "#CCCCCC",
    flash: "#669cfa",
    loading: "#CCCCCC",
    hover: "#587ebf",
    borderRadius: "10px",
    padding: "10px",
  },
  iconPosition: ButtonIconPositionShiftLeft,
  align: ButtonAlignCenter,
  flash: ButtonFlashRadial,
  allowPropagate: false,
  loader: {
    fill: "#CCCCCC",
    wheel: {
      gif: "Spinner-0.4s-310px-ffffff-transparent",
      spinnerStyle:
        "width:120%; height:120%; top:-10%; left:-10%; background-size:contain; background-position:center; background-repeat:no-repeat; position:absolute;",
    },
  },
};

export const footerButton = {
  ...greenButton,
  background: {
    active: "#405e3c",
    inactive: "#CCCCCC",
    flash: "#6ab04a",
    loading: "#CCCCCC",
    hover: "#2b4727",
    borderRadius: "10px",
    padding: "10px",
  },
  iconFromProject: true,
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
  },
};

export const formSubmitButton = {
  ...greenButton,
  iconFromProject: false,
  icon: "rounded-check_30",
  background: {
    ...greenButton.background,
    padding: "20px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
    borderRadius: "3px",
  },
};

export const formSubmitButtonBlue = {
  ...blueButton,
  iconFromProject: false,
  icon: "rounded-check_30",
  background: {
    ...blueButton.background,
    padding: "20px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
    borderRadius: "3px",
  },
};

export const gtfsrtPanelButton = {
  ...greenButton,
  iconFromProject: false,
  icon: "rounded-close-x_30",
  iconPosition: ButtonIconPositionHugLeft,
  overrideLayout: ButtonOverrideLayoutIconAndText,
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "15px",
    borderRadius: "3px",
  },
};

export const navMainSearchButton = {
  ...greenButton,
  icon: "rounded-magnifying-glass",
  iconStyle: "transform:rotate(45deg)",
  outerClasses: "sb sb-explicit hta-nav-main-search-iconbutton",
  background: {
    none: true,
    padding: "10px",
    borderRadius: "0px",
  },
  foreground: "#FFFFFF",
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "30px",
  },
  //foreground: "#acdd8c",
  // iconDimension: {
  //   style: ButtonIconActiveHeight,
  //   active: '30px'
  // },
};

export const navSearchWidgetButton = {
  ...greenButton,
  icon: "rounded-magnifying-glass",
  iconStyle: "transform:rotate(45deg)",
  outerClasses: "sb-explicit sths-nav-main-search-widget-button",
  foreground: "#FFFFFF",
  background: {
    ...greenButton.background,
    borderRadius: "4px",
    padding: "5px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
  },
};

export const prevNextSearchResultsButton = {
  ...greenButton,
  background: {
    ...greenButton.background,
    padding: "7px 20px 7px 20px",
    borderRadius: "3px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "25px",
  },
};

export const roundCloseButton = {
  ...greenButton,
  icon: "rounded-close-x_50",
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
  },
  background: {
    ...greenButton.background,
    borderRadius: "5px",
  },
  width: "50px",
  height: "50px",
};

export const roundCloseButtonRed = {
  ...redButton,
  icon: "rounded-close-x_50",
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
  },
  width: "50px",
  height: "50px",
};

export const socialMediaButton = {
  foreground: "#163E6F",
  background: {
    active: "#849CB3",
    inactive: "#CCCCCC",
    flash: "#42b6cf",
    loading: "#CCCCCC",
    hover: "#388fa1",
    borderRadius: "50%",
    padding: "3px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "50px",
  },
  iconFromProject: true,
  flash: ButtonFlashRadial,
  allowPropagate: false,
};

export const downloadPDFButton = {
  ...greenButton,
  icon: "download-rounded",
  //icon:"rounded-close-x_50",
  //iconFromProject: false,
  textStyle: "font-weight: bold",
  iconPosition: ButtonIconPositionHugRight,
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "50px",
  },
};

export const galleryLeftButton = {
  ...greenButton,
  iconFromProject: false,
  icon: "rounded-single-chevron-left",
  foreground: "#ffffff",
  background: {
    active: "rgba(0,0,0,0.6)",
    inactive: "rgba(60,60,60,0.6)",
    hover: "rgba(50, 168, 82, 0.6)",
    flash: "#79f77d",
    padding: "40px",
    borderRadius: "2px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
  },
};

export const galleryRightButton = {
  ...greenButton,
  iconFromProject: false,
  icon: "rounded-single-chevron-right",
  foreground: "#ffffff",
  background: {
    active: "rgba(0,0,0,0.6)",
    inactive: "rgba(60,60,60,0.6)",
    hover: "rgba(50, 168, 82, 0.6)",
    flash: "#79f77d",
    padding: "40px",
    borderRadius: "2px",
  },
  iconDimension: {
    style: ButtonIconActiveHeight,
    active: "20px",
  },
};

export default { name: "theme-buttons" };
</script>
